import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'

const ON = '/tuyen-dung/onboarding'
const UV = '/tuyen-dung/ung-vien'

// Lấy checklist onboarding theo ứng viên
export function layDanhSachChecklistOnboardingTheoUngVien(candidateId: number) {
  try {
    return axiosApi.get(`${UV}/${candidateId}/checklist-onboarding`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy chi tiết checklist onboarding
export function layChiTietChecklistOnboarding(id: number) {
  try {
    return axiosApi.get(`${ON}/${id}/chi-tiet`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tạo checklist onboarding
export function taoChecklistOnboarding(params: any) {
  try {
    return axiosApi.post(`${ON}/tao`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Cập nhật checklist onboarding
export function capNhatChecklistOnboarding(id: number, params: any) {
  try {
    return axiosApi.put(`${ON}/${id}/cap-nhat`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Xóa checklist onboarding
export function xoaChecklistOnboarding(id: number) {
  try {
    return axiosApi.delete(`${ON}/${id}/xoa`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
